<template>
  <div class="reset">
    <v-layout
      align-center
      justify-center
    >
      <v-flex class="rg-frame">
    <h1>{{ $t('reset.title') }}</h1>
    <v-form ref="form" class="rg-form">
      <v-text-field
        v-model="form.email"
        :rules="emailRules"
        prepend-icon="fa-envelope"
        clearable
        :label="$t('login.email')"
        @keyup.enter.native="login"
        required
      ></v-text-field>
      <v-layout
        class="rg-panel"
        column
        wrap
        justify-center
        align-center
      >
      <v-flex>
        <v-btn
          @click="resetHandle"
        >
          {{ $t('reset.send') }}
        </v-btn>
      </v-flex>
      </v-layout>
    </v-form>
  </v-flex>
  </v-layout>
  <v-footer
    color="#fbfbfb"
    height="auto"
  >
    <v-layout
    align-center
    justify-center
    >
      <v-flex rg-footer>
    <router-link :to="{ name: 'login' }">{{ $t('register.goback') }}</router-link>
      </v-flex>
    </v-layout>
  </v-footer>
  </div>
</template>
<script>
import {  mapActions } from 'vuex';
// mapState
import { EMAIL_PATTERN } from '@/utils/consts';
export default {
  name: 'Reset',
  data () {
    return {
      form: {
        email: '',
      },
      emailRules: [
        v => !!v || this.$t("login.email-required"),
        v => EMAIL_PATTERN.test(v) || this.$t("login.email-invalid"),
      ],
    };
  },
  methods: {
    ...mapActions('user', ['reset']),
    ...mapActions('alert', ['clear']),
    resetHandle: function() {
      if (this.$refs.form.validate()) {
        let email = this.form.email;
        const userData = {
          email: email,
        }
        this.reset(userData)
        }
    }
  },
  mounted() {
    this.$nextTick(function () {
        this.clear();
      })
  },
};
</script>
